/*
 © Copyright 2026 Daikin Industries, Ltd. All rights reserved.

 This software is the proprietary information of Daikin Industries, Ltd.
 By using this software, you agree to the following terms:

 1. You are granted a revocable non-exclusive, non-transferable license to use this software.
 2. You agree not to modify, distribute, or create derivative works based on this software.
 3. Unauthorized copying, distribution, or use of any portion of this software is strictly prohibited.
 4. This software is protected by copyright laws and international treaties.
 5. Any violation of these terms will result in the termination of your license and may result in legal action.
 6. This is Daikin's proprietary software and may not be used in an unauthorized manner or without express authorization from Daikin.
*/

import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ConfigService } from '../services/config.service';

/**
 * Factory function to create a redirect guard that uses ConfigService
 *
 * @param redirectKey The key in routeRedirects config (e.g., 'userRegistration', 'applicationRegistration')
 * @returns CanActivateFn that redirects to the configured URL
 */
export function configRedirectGuard(redirectKey: 'userRegistration' | 'applicationRegistration'): CanActivateFn {
  return () => {
    const router = inject(Router);
    const configService = inject(ConfigService);

    const config = configService.getConfig();
    const redirectPath = config.routeRedirects[redirectKey];

    return router.parseUrl(redirectPath);
  };
}
